import * as React from 'react';
import { Box } from '@mui/system';

import { Card, SearchResultsBanner } from 'ui';

interface Props {
  width?: string;
  searchTerm?: string;
  resultCount?: number;
  children?: React.ReactNode;
}

export const TableContainer: React.FC<Props> = (props) => {
  return (
    <>
      <SearchResultsBanner searchTerm={props.searchTerm} resultCount={props.resultCount} />
      <Box
        sx={{
          '.MuiCardContent-root': {
            padding: '0 !important'
          },
          width: props.width || 'auto'
        }}
      >
        <Card noPadding={true}>{props.children}</Card>
      </Box>
    </>
  );
};
